// External libraries
import React from 'react';

// Internal modules
import { WalletLogoWrap, WalletName, WalletOption } from './StyledComponents';
import type { CheckoutOption } from './types';

const getSafeRedirectUrl = (url: string): string => {
  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'https:' || parsed.protocol === 'http:') {
      return url;
    }
  } catch {
    if (url.startsWith('/')) {
      return url;
    }
  }
  return '#';
};

export type WalletRowProps = {
  wallet: CheckoutOption;
  onWalletClick: (wallet: CheckoutOption) => void;
  tabIndex?: number;
};

export const WalletRow = ({
  wallet,
  onWalletClick,
  tabIndex,
}: WalletRowProps): React.ReactElement => {
  const safeRedirectUrl = getSafeRedirectUrl(wallet.redirectUrl);

  return (
    <WalletOption
      href={safeRedirectUrl}
      data-testid={`wallet-option-${wallet.label}`}
      tabIndex={tabIndex}
      onClick={event => {
        if (safeRedirectUrl === '#') {
          event.preventDefault();
        }
        onWalletClick(wallet);
      }}
    >
      <WalletLogoWrap>
        <img src={wallet.logoUrl} alt="" />
      </WalletLogoWrap>
      <WalletName>{wallet.name}</WalletName>
    </WalletOption>
  );
};
